import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageAPL5 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "France Kicks Off 2027",
            author: "footballgirl",
              date: "Fevrier, 2026",
            image: "images/apl/4a.jpg",
             content: `<h3>France Kicks Off 2027 Women's World Cup Qualification Campaign</h3>

<p class="date">March 3, 2026</p>

<p>The French women's national team, Les Bleues, has launched their qualification campaign for the <strong>2027 FIFA Women's World Cup</strong> (to be held in Brazil) this week as part of the UEFA Women's European Qualifiers. The competition uses a league format tied to the Women's Nations League structure, with the four League A group winners earning direct qualification to the World Cup finals, while others enter playoffs.</p>

<p>France is placed in <strong>Group A2</strong> alongside strong opponents: the Netherlands (a consistent major tournament contender and 2019 World Cup runners-up), the Republic of Ireland (recently promoted to League A after a strong Nations League playoff and aiming for back-to-back World Cup appearances following their 2023 debut), and Poland (also newly promoted, bolstered by talents like Barcelona's prolific forward Ewa Pajor).</p>

<h2>Opening Fixtures</h2>

<p>The campaign kicks off with two matches in the March international window:</p>

<ul>
    <li><strong>Tuesday, March 3, 2026</strong>: Republic of Ireland vs. France at Tallaght Stadium, Dublin (kick-off 19:30 local time / 20:30 CET). This away fixture pits Les Bleues against a resilient Irish side that has shown they can challenge top teams, including a notable home win over France in prior qualifiers.</li>
    <li><strong>Saturday, March 7, 2026</strong>: France vs. Poland at Stade Gaston-Gérard, Dijon (kick-off around 21:10 local time). This home game offers France a chance to build momentum in front of their supporters.</li>
</ul>

<h2>Team News and Squad</h2>
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>

<p>Coach <strong>Laurent Bonadei</strong>, who has led the team since succeeding Hervé Renard and guided them to success at UEFA Women's EURO 2025, has assembled a 26-player squad featuring experience and emerging talent. It includes <strong>Pauline Peyraud-Magnin</strong> (goalkeeper for NWSL's Denver Summit, expected to start), but several key players are sidelined due to injuries, such as Selma Bacha, Delphine Cascarino, and Griedge Mbock. Bonadei has emphasized starting strongly with a possession-based, attacking style to secure early points and aim for the group top spot.</p>

<h2>Ambitions for the Campaign</h2>

<p>France, ranked highly in the world (around 6th in recent FIFA listings), views these opening fixtures as critical in a competitive group where only the winner advances directly. Matches continue in April (including a key clash with the Netherlands) and June, with the league phase concluding later in 2026.</p>

<p>By targeting maximum points from these initial games, Les Bleues aim to establish dominance and secure their spot at Brazil 2027—their sixth World Cup appearance—while building cohesion under Bonadei's vision for greater international success.</p>
<h1>法国开启2027年女足世界杯预选赛征程</h1>

<p class="date">2026年3月3日</p>

<p>法国女子国家足球队“蓝姑娘”（Les Bleues）本周正式启动了2027年国际足联女子世界杯（将在巴西举办）的资格赛征程，这是作为欧洲足联女子欧洲预选赛的一部分。该赛事采用与女子国家联赛相挂钩的联赛制，A级联赛四个小组的头名将直接晋级世界杯决赛圈，其余队伍进入附加赛。</p>

<p>法国被分在<strong>A2组</strong>，同组对手实力强劲：荷兰（长期大赛劲旅，2019年世界杯亚军）、爱尔兰共和国（通过国家联赛附加赛升入A级，力争继2023年世界杯首秀后连续参加世界杯）、波兰（同样新晋A级，由巴萨锋线射手埃娃·帕约尔等人才领衔）。</p>

<h2>开赛赛程</h2>

<p>预选赛在3月国际比赛窗口拉开帷幕，两场比赛如下：</p>

<ul>
    <li><strong>2026年3月3日（周二）</strong>：爱尔兰共和国 vs 法国，地点：都柏林塔拉赫特球场（当地时间19:30 / 中欧时间20:30）。这场客场比赛让蓝姑娘面对一支韧性十足的爱尔兰队，此前爱尔兰曾在主场爆冷击败过法国。</li>
    <li><strong>2026年3月7日（周六）</strong>：法国 vs 波兰，地点：第戎加斯东-热拉尔球场（当地时间约21:10）。这场主场比赛为法国队提供了在主场球迷面前积累势头的良机。</li>
</ul>

<h2>球队新闻与阵容</h2>

<p>主教练<strong>洛朗·博纳迪</strong>自接替埃尔韦·勒纳尔以来执教球队，并在2025年欧洲女子足球锦标赛上取得成功。他召集了26人阵容，融合了经验与新星。其中包括NWSL丹佛峰队门将<strong>保利娜·佩罗-马尼安</strong>（预计首发），但多名关键球员因伤缺阵，如塞尔玛·巴沙、德尔芬·卡斯卡里诺和格里埃杰·姆博克。博纳迪强调开局要强势，采用控球为主、进攻导向的风格，力争小组头名早早锁定直接出线资格。</p>

<h2>征程目标</h2>

<p>法国在最新FIFA世界排名中位居前列（约第6位），视这两场开局战为关键战役。在这个竞争激烈的小组中，仅小组第一直接晋级。后续比赛将在4月（包括与荷兰的关键对决）和6月继续进行，联赛阶段将于2026年晚些时候结束。</p>

<p>通过在前两场比赛中力争全取6分，蓝姑娘旨在确立小组主导地位，锁定2027年巴西世界杯席位——这将是她们第六次参加女足世界杯，同时在博纳迪的执教理念下进一步提升国际竞争力。</p>`
,
tags: ["france", "qualification", "World Cup 2027", "laurent bonadei", "pauline peyraud-magnin", "selma bacha", "delphine cascarino", "griedge mbock"],
            readingTime: "6 min read",          
navIndices: { prev: 'apl-4', next: 'apl-6' }
        });
    }

    init() {
        console.log('ArticlePageAPL5 initialized');
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to APL
            `;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'apl' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_apl.png';
            leagueLogo.alt = 'APL';
        }
    }
}